import type { SimulationListEntryDto } from '@/api';
import simulationListFilteredEmptyState from '@/assets/simulation-list-filtered-empty-state.svg';
import { ResponsiveEmptyStateIllustration } from '@/components/responsive-empty-state-illustration';
import { Button } from '@lego/connect-components-react';
import type { MRT_TableInstance } from 'material-react-table';
import type { ReactElement } from 'react';

// Vertical padding plus the clear filters button below the illustration
const NON_ILLUSTRATION_HEIGHT = 104;

// Shown in place of the table rows when filters/search hide every simulation
export const FilteredEmptyList = ({
  table,
}: {
  table: MRT_TableInstance<SimulationListEntryDto>;
}): ReactElement => {
  const container = table.refs.tableContainerRef.current;
  const headHeight = table.refs.tableHeadRef.current?.clientHeight ?? 0;
  // The rows area is the scroll container minus the sticky header
  const availableHeight = container
    ? container.clientHeight - headHeight
    : undefined;

  return (
    <div
      style={{
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        height: availableHeight ? `${availableHeight}px` : 'auto',
        justifyContent: 'center',
        left: 0,
        minHeight: '240px',
        padding: '16px',
        position: 'sticky',
        width: container ? `${container.clientWidth}px` : '100%',
      }}
    >
      <ResponsiveEmptyStateIllustration
        src={simulationListFilteredEmptyState}
        alt="Your filters might be hiding your simulations"
        maxWidth={1502}
        height="auto"
        maxHeight={
          availableHeight
            ? `${availableHeight - NON_ILLUSTRATION_HEIGHT}px`
            : undefined
        }
      />
      <Button
        onClick={() => {
          table.resetColumnFilters(true);
          table.resetGlobalFilter(true);
        }}
        aria-label="Clear filters"
      >
        Clear filters
      </Button>
    </div>
  );
};
